import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentSummitPulseEngagementBreakdown on SummitPulseEngagementBreakdown {
    thriving
    engaged
    atRisk
    disengaged
    summary
  }
`
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentSummitPulseEngagementBreakdownFragment,
  ents.core.summit.Pulse.EngagementBreakdown
>({
  atRisk: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeAsserter.assertIsNotNullish,
    {
      warnOnly: true,
    },
  ),
  disengaged: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeAsserter.assertIsNotNullish,
    {
      warnOnly: true,
    },
  ),
  engaged: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeAsserter.assertIsNotNullish,
    {
      warnOnly: true,
    },
  ),
  summary: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeAsserter.assertIsNotNullish,
    {
      warnOnly: true,
    },
  ),
  thriving: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeAsserter.assertIsNotNullish,
    {
      warnOnly: true,
    },
  ),
})
